import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import { SupportedTimezone } from '@shared/services/datetime/datetime.utils';

@Pipe({
  standalone: true,
  name: 'translateTimezone',
})
export class TranslateTimezonePipe implements PipeTransform {
  public transform(value: SupportedTimezone): string {
    const name = getTimezoneName(value);
    const offset = dayjs().tz(value).format('Z');

    return `${name} (${offset})`;
  }
}

function getTimezoneName(value: SupportedTimezone): string {
  switch (value) {
    case 'America/New_York':
      return 'EST';
    default:
      return value;
  }
}

// undefined as EST (temp solution until backend change the name for America/New_York)
export function toApiTimezone(value?: SupportedTimezone) {
  return value === 'America/New_York' ? undefined : value;
}
